import React from 'react';

const DorchesterTheme = {
  headerLogo: {
    src: '/themes/theme/dc/dc-logo.png',
    alt: 'Dorchester Collection Logo',
    size: 70,
  },
  darkLogo: {
    src: '/themes/theme/dc/logo-dark.png',
    alt: 'Dorchester Collection Logo',
    size: 60,
  },
  headerStyle: {
    backgroundColor: '#000',
    borderBottom: '2px solid #CCC',
    height: 80,
  },
  linkStyle: {
    color: '#FFF',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'Dorchester Collection',
  isLightOnDark: true,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img height="40" src="/themes/theme/dc/logo-dark.png" alt="Dorchester Collection Logo" />
      <br /><br />
      <h3>Dochester Collection Creators</h3>
      <br /><br />
      <p>Nine iconic addresses, nine extraordinary hotels, one unique collection. One global compass guiding you to the only destinations you’ll ever need.</p>
    </div>
  ),
  shareSite: 'https://share.dorchestercollection.com',
  copy: {
    joinTitle:
     'Join the Dorchester Collection Creators Network today',

    joinDescription: (
      <div>
        <p>We offer you the opportunity to join our Creator network and collaborate with our hotel collection.</p>
        <p>We just ask that you update your member details so we can verify who you are!</p>
      </div>
    ),

    featureList: (
      <div>
        <h4>Please verify your details so we can add you to the network</h4>
        <ul>
          <li>Check your Creator name</li>
          <li>Add address details so we can add you to our creator directory</li>
          <li>Add social handles to benefit from creator incentives</li>
          <li>Start sharing your content with our community</li>
        </ul>
      </div>
    ),

    applicationFormInstructions: (
      <div>
        <p>Please fill in this short form to complete your application.</p>
        <br />
        <p>
          Our Creator Network is free to join,
           no contracts and your data is not shared without your permission
        </p>
        <br />
        <p>
          All creator accounts are manually checked
           by our team before gaining access to the platform, we’ll be in touch soon.
        </p>
      </div>
    ),
  },
};

export default DorchesterTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/dorchester.js
 **/